import { SiteInit } from './assets/siteinit';
import { CSSAcdn } from './assets/accordion';
import { SA } from './assets/scrollAnimation';

/*
SiteInit option default
{
	menuBtn: '#menuBtn', //メニューボタンのセレクタ
	menu: '#menu', //メニューのセレクタ
	anchorIgnore: '.noscroll', //スムーススクロールを適用しない要素のセレクタ
	anchorSpeed: 300, //スムーススクロールのスピード
}
*/

const siteInit = new SiteInit();


/*
ScrollAnimation option default
{
	sa: '.anm', //スクロールアニメーションのセレクタ
	saMargin: window.innerHeight * 0.2 //スクロールアニメーションを適用する要素を表示させる位置（デフォルトは画面の一番下から20%の位置）
}
*/

const sa = new SA();

/*
CSSAcdn option default
{
	switchClass: 'open', //開く時に追加するクラス名
}
*/

const acdn = new CSSAcdn();
const btns = document.querySelectorAll('.acdnButton');
const closeBtns = document.querySelectorAll('.acdnClose');
const acdnContents = document.querySelectorAll('.acdnContents');

for (let i = 0; i < acdnContents.length; i++) {
	acdnContents[i].classList.add('acdn-active');
}

for (let i = 0; i < btns.length; i++) {
	btns[i].addEventListener('click', (e) => {
		let target = e.currentTarget.nextElementSibling;
		acdn.toggle(target);
	}, false);
}

for (let i = 0; i < closeBtns.length; i++) {
	closeBtns[i].addEventListener('click', (e) => {
		let target = e.currentTarget.parentNode.parentNode.parentNode;
		acdn.close(target);
		siteInit.anchorScroll(target.parentNode.querySelector('.anchor'));
	}, false);
}
